import * as Types from '@/__gen/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveEmailContactMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RemoveEmailContactMutation = { __typename: 'PharosMutations', email_Update: { __typename: 'emailPayload', object: { __typename: 'EmailType', id: string, excludeFromAddressBook: boolean } | null, errors: Array<{ __typename: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };


export const RemoveEmailContactDocument = gql`
    mutation removeEmailContact($id: ID!) {
  email_Update(input: {id: $id, excludeFromAddressBook: true}) {
    object {
      id
      excludeFromAddressBook
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type RemoveEmailContactMutationFn = Apollo.MutationFunction<RemoveEmailContactMutation, RemoveEmailContactMutationVariables>;

/**
 * __useRemoveEmailContactMutation__
 *
 * To run a mutation, you first call `useRemoveEmailContactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmailContactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmailContactMutation, { data, loading, error }] = useRemoveEmailContactMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEmailContactMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmailContactMutation, RemoveEmailContactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmailContactMutation, RemoveEmailContactMutationVariables>(RemoveEmailContactDocument, options);
      }
export type RemoveEmailContactMutationHookResult = ReturnType<typeof useRemoveEmailContactMutation>;
export type RemoveEmailContactMutationResult = Apollo.MutationResult<RemoveEmailContactMutation>;
export type RemoveEmailContactMutationOptions = Apollo.BaseMutationOptions<RemoveEmailContactMutation, RemoveEmailContactMutationVariables>;